import { twMerge } from '@utils/twMerge';
import { Tag, Tooltip } from 'antd';
import { FC } from 'react';
import { Option } from '@utils/generateOptions';
import { CloseIcon } from '@dynamika-shared/ui/icons';

const MAX_LABEL_LENGTH = 35;

type SelectedTagsProps = {
  selectedItems: Option[];
  onClose: (item: Option) => void;
  className?: string;
};
export const SelectedTags: FC<SelectedTagsProps> = ({
  selectedItems,
  onClose,
  className,
}) => {
  return (
    <div className={twMerge(className, 'flex flex-wrap gap-[8px] mt-[8px]')}>
      {selectedItems.map(item => (
        <Tag
          key={item.value}
          closeIcon={
            <CloseIcon
              width={20}
              height={20}
              className={'group-hover/tag:text-white'}
            />
          }
          closable
          onClose={() => onClose(item)}
          className='group/tag hover:bg-[#1D8EF2] flex items-center bg-[#F6F9FF] rounded-[8px] py-[6px] ps-[16px] pe-[8px] border border-brightGray'
        >
          <Tooltip
            color='white'
            title={
              item.label.length > MAX_LABEL_LENGTH ? (
                <span className='text-1424 text-black'>{item.label}</span>
              ) : undefined
            }
          >
            <span
              className={twMerge(
                'text-dimGray text-1420 font-regular leading-6 group-hover/tag:text-white',
                item.label.length > MAX_LABEL_LENGTH &&
                  `max-w-[${MAX_LABEL_LENGTH}rem] truncate`
              )}
            >
              {item.label}
            </span>
          </Tooltip>
        </Tag>
      ))}
    </div>
  );
};
